<div *ngIf="$email"><p>Good news! We found your account and populated your email below. If you don’t have access to this email account, click on ‘Create an Account’ below.
  </p>
</div>
<h3 *ngIf="isShowCCDown" style="color: red;">Due to circumstances beyond our control, we are unable to process credit card payments online at this time. We apologize for any inconvenience this may cause.</h3>
<div *ngIf="$myMessage"><p>{{$myMessage}}</p></div>
<div class="sign-in">
  <div class="sign-in__col">
    <h1 class="page-title">Sign In</h1>
    <form [formGroup]="signInForm" (ngSubmit)="onSubmit(signInForm.value)" class="form sign-in-form">
      <div class="field">
        <label for="email" class="label">Email</label>
        <input class="input input--medium" [class.input--invalid]="formErrors.email" id="email" formControlName="email" type="email" placeholder="" autocomplete="off" />
        <div *ngIf="formErrors.email" class="error-message field__error-message">{{ formErrors.email }}</div>
      </div>
      <div class="field">
        <label for="" class="label">Password</label>         
        <div class="password-container">                    
            <input class="input input--medium" [class.input--invalid]="formErrors.password" id="password" formControlName="password" type="{{ showPassword ? 'text' : 'password' }}" placeholder="" autocomplete="off" />
            <img src="/assets/images/eye.svg" title="show password" (click)="toggleShowPassword();" height="10" width="10" />          
        </div>                
        <div *ngIf="formErrors.password" class="error-message field__error-message">{{ formErrors.password }}</div>
      </div>
      <div *ngIf="loginError" class="error-message field__error-message">{{loginError}}</div>
      <div class="form-actions">
        <input class="button form-actions__item" type="submit" value="Sign In">
      </div>
      <div class="form-actions">
        <a routerLink="forgot-password" class="form-actions__item">Forgot Password?</a>
        <a routerLink="forgot-login" class="form-actions__item">Forgot Email?</a>
        <div class="form-actions__item form-actions__item--full">
          <div>Don't have an account?</div>
          <a routerLink="create-account" class="form-actions__item">Create an Account</a>
        </div>
      </div>
    </form>
  </div>
  <div class="sign-in__col sign-in__instructions">
    <h2 class="heading--5">If you hold a credential with the NBRC or have previously attempted an examination:</h2>
    <ul>
      <li>Enter the email and password you previously established.</li>
      <li>If you don’t have an account established, please select the ‘Create an Account’ link.</li>
    </ul>
    <h2 class="heading--5">If you are a recent graduate from an accredited educational program:</h2>
    <ul>
      <li>An email was sent to you when your school submitted your graduation information electronically. Use the link and temporary password in your email to establish an account. If you did not receive an email with this information, please contact your school to verify your graduation record has been sent to our office.</li>
    </ul>
    <h2 class="heading--5">To apply for the AE-C examination:</h2>
    <ul>
      <li>You may apply online <a href="/auth/create-profile">here</a> if you have a current, active, unrestricted license or credential from the United States.</li>
      <li>If you are applying for the examination with 1,000 hours of direct patient asthma education, 
          counseling or coordinating services you must submit a <a href="https://nbrc.org/ae-c-application">paper application</a> form and payment. 
          If you do not have an active US license or credential, you must apply under this eligibility route. </li>
    </ul>    
  </div>
</div>
<div style="color:blue; font-size:8pt;">
  For optimal performance we encourage using a compatible internet browser such as the current version of Internet Explorer or Chrome. Using Safari or Firefox may not allow you to access all components of your online record.
</div>

